import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";

const NoticeOptionSection = ({
  popupImageUrl,
}: {
  popupImageUrl: string | null;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.notice_option")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t("quest_detail.field.notice_option.popup_image"),
          children: popupImageUrl && <Box component="img" src={popupImageUrl} />,
        },
      ]}
    />
  );
};

export default NoticeOptionSection;
